module.exports = __webpack_public_path__ + "85f93cce95b8e82ac25694609efd17bc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-aviators-s.png
// module id = 2431
// module chunks = 0